import { StorageAdapter } from '../StorageAdapter'

/**
 * Wraps an injected secure-storage backend (mobile Keychain/Keystore).
 *
 * The mobile app passes its own `react-native-keychain` (or equivalent)
 * wrapper in. We don't import the native module here because (a) the
 * package must build without react-native types in web typecheck, and
 * (b) it keeps the dependency direction one-way (apps own native deps).
 */
export interface SecureStorageBackend {
    getItem: (key: string) => Promise<string | null>
    setItem: (key: string, value: string) => Promise<void>
    removeItem: (key: string) => Promise<void>
}

export const createSecureStorage = (backend: SecureStorageBackend): StorageAdapter => ({
    name: 'secureStorage',
    get: key => backend.getItem(key),
    set: (key, value) => backend.setItem(key, value),
    remove: key => backend.removeItem(key),
})
